<template>
    <!-- Main Content Start -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Stock Transfer List</h2>
        </div>
        
       <!-- Filter Form -->
<div class="card p-4 mb-4">
    <form @submit.prevent="filterPurchases">
        <div class="flex flex-col lg:flex-row lg:items-center lg:space-x-4 space-y-4 lg:space-y-0">

          <!-- Start Date -->
          <div class="w-full lg:w-auto mt-4">
            <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
            <input type="date" id="startDate" v-model="startDate" class="p-2 border border-gray-300 rounded w-full" />
        </div>
        
        <!-- End Date -->
        <div class="w-full lg:w-auto ml-2">
            <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
            <input type="date" id="endDate" v-model="endDate" class="p-2 border border-gray-300 rounded w-full" />
        </div>

         <!-- Filter Button -->
         <div class="w-50 lg:w-auto ml-2">
            <button type="submit" class="btn b-solid btn-primary-solid px-5 cursor-pointer w-full lg:w-auto mt-2 lg:mt-6">Filter</button>
        </div>  
            <!-- Vendor Filter -->
            <div class="w-full lg:w-auto ml-2 mt-4"  style="width: 150px;">
                <label for="from_branch" class="block text-sm font-medium text-gray-700">Search From Branch</label>
                <select class="form-input w-full p-2 border border-gray-300 rounded" id="from_branch" ref="from_branch" v-model="sale.from_branch">
                    <option value="0">ALL</option>
                    <option v-for="(item, index) in Frombranchlist" :key="index" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
            
            <!-- Product Filter -->
            <div class="w-full lg:w-auto ml-2" style="width: 150px;">
                <label for="to_branch" class="block text-sm font-medium text-gray-700">Search To Branch</label>
                <select class="form-input w-full p-2 border border-gray-300 rounded" id="to_branch" ref="to_branch" v-model="sale.to_branch">
                    <option value="0">ALL</option>
                    <option v-for="(item, index) in branchList" :key="index" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
            
           
        </div>
    </form>
</div> 

<div class="w-full lg:w-auto lg:ml-2 mt-4 mb-2 ml-2">
    <button @click="exportToExcel" class="w-full lg:w-auto btn btn-primary-solid px-5 mt-2 lg:mt-6 cursor-pointer">
        Export
    </button>
</div>   


                <div class="card">
                    <!-- Static heading -->
                    <div id="printable-content">
                        <h1 class="print-only" style="text-align: center;">Zambre Patil Prayog Parivar</h1>
                        <h1 class="print-only" style="text-align: center;">Material Transcation</h1>
                    </div>

                    <button
                        type="reset"
                        @click="printReceipt"
                        class="btn b-light btn-danger-light btn-sm"
                    >
                        Print
                    </button>
                    </div>

                    <div class="printonly">
                        From {{startDate}} To {{endDate}}
                    </div>


       
<!-- Table Content -->
<div class="grid grid-cols-12">
    <div class="col-span-full">
        <div class="card p-0">
            <div class="p-6 space-y-4">
                <!-- Add responsive wrapper for scrolling -->
                <div class="overflow-x-auto">
                    <table id="basicDataTable" class="datatable1 min-w-full border divide-y divide-gray-200 dark:divide-dark-border">
                        <thead class="bg-[#B2E8D9]">
                            <tr>
                                <th class="p-2 text-left text-gray-600 whitespace-nowrap">Tr.ID</th>
                                <th class="p-2 text-left text-gray-600 whitespace-nowrap">Transfer Date</th>
                                <th class="p-2 text-left text-gray-600 whitespace-nowrap">User Name</th>
                                <th class="p-2 text-left text-gray-600 whitespace-nowrap">From Branch</th>
                                <th class="p-2 text-left text-gray-600 whitespace-nowrap">To Branch</th>
                                <th class="p-2 text-left text-gray-600 whitespace-nowrap">Note</th>
                                <th class="p-2 text-left text-gray-600 whitespace-nowrap">Operation</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                            <tr v-for="(item, index) in stocktransferList" :key="item.id" class="hover:bg-gray-50">
                                <td class="p-2">{{ item.id }}</td>
                                <td class="p-2">{{ item.entry_date }}</td>
                                <td class="p-2">{{ item.user_name }}</td>
                                <td class="p-2">{{ item.from_branch }}</td>
                                <td class="p-2">{{ item.to_branch }}</td>
                                <td class="p-2">{{ item.note }}</td>
                                <td class="p-2">
                                    <div class="flex items-center gap-1">


                                        <button class="btn-icon btn-primary-icon-light size-7" @click="StockTransferView(item.id)">
                                            <i class="ri-edit-line text-success text-[13px]"></i>
                                        </button>


                                        <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                            <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                        </button>

                                        <button class="btn-icon btn-primary-icon-light size-7" @click="print_invoice(item.id)">
                                            <i class="ri-printer-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

    </div>




       <!-- Start Delete Modal -->
       <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->






    <!-- Main Content End -->
</template>

<script>
import axios from 'axios';

export default {
    name: 'salarySlipReport',
    watch: {
        stocktransferList () { // data used in the table
           this.$nextTick (() => { // wait until data fully updated before re-render new DOM 
             $('.datatable').DataTable().draw();
             this.reinitializeDataTable();
           })
         },
         
     },
    data() {
        const today = new Date().toISOString().split('T')[0];
        return {
            salslipList: [],
            branchList:[],
            filteredsalslipList: [],
            stocktransferList:[],
            Frombranchlist:[],
            original_stocktransferList:[],
            datatable: null,
            startDate:new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
            endDate: today,
            isTableVisible: false, // Initially table is hidden
            totalMale: 0,
            totalMaleAmount: 0,
            totalFemale: 0,
            totalFemaleAmount: 0,
            totalGadiAmount: 0,
            totalAmount: 0,
            sale: {
                from_branch: null,
                to_branch:null,
        },
        };
    },
    mounted() {
        //this.getBasics();
    },
    watch: {
        // stocktransferList() {
        //     // this.$nextTick(() => {
        //     //     $('.datatable').DataTable().draw();
           
        //     // });
        // },
    },
    methods: {
        getSalarySlipDetails(id) {
            window.open('/salaryslipdetails?q=' + id, '_blank');
        },

        exportToExcel() {
        // Prepare the CSV header
        const headers = ["entry_date", "user_name ", "from_branch", "to_branch", "note"];
        const rows = this.stocktransferList.map(item => [
        this.formatDate(item.entry_date),
            item.user_name ,
            item.from_branch,
            item.to_branch,
            item.note,
        ]);

        // Combine headers and rows into a CSV string
        const csvContent = [headers, ...rows]
            .map(row => row.map(value => `"${value}"`).join(","))
            .join("\n");

        // Create a Blob from the CSV content
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        // Trigger a download
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "stocktransfer_Report.csv");
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },

    formatDate(date) {
    if (!date) return "";  // Return empty string if date is missing or null
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";  // Return empty if invalid date
    return d.toLocaleDateString();  // Format the date as per your requirement
},



        calculateAmount(bhade, rate) {
            return (bhade * rate).toFixed(2);
        },





   closeModal(){
     
     $("#editModal").addClass('hidden');
     $("#deleteModal").addClass('hidden');
         this.isAdd=0;
         this.isEdit=0;
         this.isDelete=0;
         this.deleteId=0;
  },

  deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },








        async getBasics() {
            const self = this;
            axios.post('gettransfterprd').then(function (response) {
                self.salslipList = response.data.salslipList;
                self.branchList = response.data.branchlist;
                self.stocktransferList = response.data.products;
                self.original_stocktransferList = response.data.products;
                self.Frombranchlist = response.data.frombranchList;
            }).then(() => {


                // $("#from_branch").select2({
                //                         width: '80%',
                //                         dropdownAutoWidth : true,
                //                         placeholder:"Search From Branch Here...",
                //                     "language": {
                //                                 "noResults": function(){
                //                                     return "No Results Found ";
                //                                 }
                //                             },
                //                                 escapeMarkup: function (markup) {
                //                                     return markup;
                //                                 }
                //                     }).on('change', function (event) {
                //                         //alert(event.target.value);
                //                             // self.sale.branchid=event.target.value; 
                //                             //self.productsList.slice(0); 
                //                             self.stocktransferList.slice(0); 
                //                             if(event.target.value>0) {
                //                                 self.stocktransferList=self.original_stocktransferList.filter(item => item.frombranch === event.target.value);
                                               
                //                             }else{
                //                                  self.stocktransferList=self.original_stocktransferList;
                //                             }    
                //                             $('.datatable').DataTable().destroy();                
                                            
                //                         });


                                    //     $("#to_branch").select2({
                                    //     width: '80%',
                                    //     dropdownAutoWidth : true,
                                    //     placeholder:"Search To Branch Here...",
                                    // "language": {
                                    //             "noResults": function(){
                                    //                 return "No Results Found ";
                                    //             }
                                    //         },
                                    //             escapeMarkup: function (markup) {
                                    //                 return markup;
                                    //             }
                                    // }).on('change', function (event) {

                                    //      self.stocktransferList.slice(0); 
                                    //         if(event.target.value>0) {
                                    //             self.stocktransferList=self.original_stocktransferList.filter(item => item.tobranch === event.target.value);
                                               
                                    //         }else{
                                    //             self.stocktransferList=self.original_stocktransferList;
                                    //         }
                                    //         $('.datatable').DataTable().destroy();
                                            
                                    //     });

            });
        },



destroyTable(){
    if ($.fn.dataTable.isDataTable('#basicDataTable')) {
                        $('#basicDataTable').DataTable().destroy();
                    }
},
initiateTable(){
   this.$nextTick(() => {  $('#basicDataTable').DataTable( {
                dom: 'Bfrtip',
                buttons: [
                    'print',
                    'excelHtml5',
                    'csvHtml5',
                    'pdfHtml5'
                ]
            } );  } );
},

          async filterPurchases() {
            const self = this;
            axios.post('gettransfterprd',{fromdate:self.startDate,todate:self.endDate}).then(function (response) {
                 self.destroyTable();  
                self.salslipList = response.data.salslipList;
                self.branchList = response.data.branchlist;
                self.stocktransferList = response.data.stocktransferList;
                self.original_stocktransferList = response.data.stocktransferList;
                self.Frombranchlist = response.data.frombranchList;
            }).then(() => {

                 self.initiateTable();//$("#basicDataTable").DataTable();
                
                $("#from_branch").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search From Branch Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found ";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        //alert(event.target.value);
                                            // self.sale.branchid=event.target.value; 
                                            //self.productsList.slice(0); 
                                            self.destroyTable();  
                                            
                                         //   self.stocktransferList.slice(0); 
                                             if(event.target.value>0) {
                                                self.stocktransferList=self.original_stocktransferList.filter(item => item.frombranch === event.target.value);
                                               
                                            }else{
                                                 self.stocktransferList=self.original_stocktransferList;
                                            }    
                                                 
                                            self.initiateTable();
                                        });


                                        $("#to_branch").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search To Branch Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found ";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                       // alert(event.target.value);
 self.destroyTable();
                                        // self.stocktransferList.slice(0); 
                                             if(event.target.value>0) {
                                                self.stocktransferList=self.original_stocktransferList.filter(item => item.tobranch === event.target.value);
                                               
                                            }else{
                                                self.stocktransferList=self.original_stocktransferList;
                                            }
                                           self.initiateTable();
                                            
                                        });

            });
        },
       



        filterSalarySlip() {
            if (this.datatable) {
                this.datatable.destroy();
            }

            let filteredList = this.salslipList;
            if (this.startDate) {
                filteredList = filteredList.filter(item => new Date(item.entrydate) >= new Date(this.startDate));
            }

            if (this.endDate) {
                filteredList = filteredList.filter(item => new Date(item.entrydate) <= new Date(this.endDate));
            }

            this.filteredsalslipList = filteredList;

            this.$nextTick(() => {
                this.datatable = $(".datatable").DataTable({
                    paging: true,
                    ordering: true,
                    autoWidth: false
                });
            });
        },
        filterByParentName(parentName) {
            if (this.datatable) {
                this.datatable.destroy();
            }

            this.filteredsalslipList = this.salslipList.filter(item => item.parent_name === parentName);

            this.$nextTick(() => {
                this.datatable = $(".datatable").DataTable({
                    paging: true,
                    ordering: true,
                    autoWidth: false
                });
            });

          
        },

        print_invoice(id) {
            window.open('/stocktransferPrints?q=' + id, '_blank');
        },

        printReceipt() {
            $('.datatable').DataTable().destroy(); 
             window.print();
    },


    StockTransferView(id)
        {
             
               // window.open('/print?q='+id, '_blank');
                window.open('/stocktransfer?q='+id, '_blank'); 
        },





    delete_category() {
                var self = this; 
                axios.post('deletestocktranserferlist', {deleteId:this.deleteId})
                    .then(response => {
                        // self.productsList=response.data.products;
                        // self.employees=response.data.userDetails; 
                         self.filterPurchases();
                         self.closeModal(); 
                         //location.reload();
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },


      
    }
}
</script>


<style scoped>
    tfoot{
        background: antiquewhite;
        font-size: medium;
        font-weight: 800;
    }
    tfoot td{
        height: 35px;
    }
    .print-only {
        display: none;
    }
    .printonly{
        display: none; 
    }
    
    @media print {
        .print-only {
            display: block; /* Show elements for print */
            text-align: center; /* Center alignment as needed */
            font-size: 16px; /* Font size adjustments if needed */
        }
        .printonly{
            display: block;
        }
    }
    
    
    @media print {
        /* Hide unnecessary elements */
        button, select, input, h2, .header_class, .header, .card-title {
            display: none !important;
        }
        
    
        /* Adjust the layout */
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
        }
    
        /* Receipt container */
        .receipt-container, #printable-content {
            width: 100%;
            padding: 10mm;
            margin: auto;
            border: 1px solid #000;
        }
    
        /* Add a border and spacing to the table */
        table {
            width: 100%;
            border-collapse: collapse;
        }
    
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-size: 12px;
            color: black !important; 
        }
    
        
        table th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: black!important;
        }
    
        /* Center titles */
        h1, h2 {
            text-align: center;
            margin: 0 0 10px;
            font-size: 16px;
            font-weight: bold;
        }
    
        /* Add company branding details */
        #printable-content {
            text-align: center;
        }
    
        #printable-content h1 {
            font-size: 20px;
        }
    
        /* Add spacing between sections */
        .section {
            margin-bottom: 20px;
        }
    
        /* Performance container styling */
        .performance-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
    
        .performance-box {
            flex: 1;
            padding: 5px;
            margin: 0 5px;
            border: 1px solid #ddd;
            font-size: 12px;
            text-align: center;
        }
    
        .performance-box.best {
            background-color: #c8e6c9;
        }
    
        .performance-box.good {
            background-color: #bbdefb;
        }
    
        .performance-box.average {
            background-color: #ffe0b2;
        }
    }
    
      
        .salary_input{
            padding: 5px;
            width: 70px;
        }
        .plotname{
            font-size: x-small;
        font-weight: 200;
        background: yellow;
        padding: 0px 2px;
        border-radius: 10px;
        }
    
        .performance-container {
          display: flex;
          gap: 20px;
        }
        .performance-box {
          padding: 1px;
          border-radius: 8px;
          color: white;
          text-align: center;
          font-weight: bold;
          width: 80px;
        }
        
        .Best1 {
          background-color: green;
        }
        .Good1 {
          background-color: blue;
        }
        .Average1 {
          background-color: orange;
        }
    
        .best {
      color: green;
    }
    .good {
      color: blue;
    }
    .average {
      color: orange;
    }
    </style>
    










<style>



@media print {
    button, select, input, h2, .header_class, .header, .card-title,select,label,.select2 {
        display: none !important;
    }
    

}

    .suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}
</style>